type StylisElement = {
    parent: StylisElement | null
    root: StylisElement | null
    type: string
    props: string[] | string
    value: string
    children: StylisElement[] | string
    return: string
    line: number
    column: number
    length: number
}

type StylisMiddleware = (
    element: StylisElement,
    index: number,
    children: StylisElement[],
    callback: StylisMiddleware,
) => string | void

const WRAPPABLE_AT_RULES = new Set(['@media', '@supports', '@container'])

export const legacyLayerWrapPlugin: StylisMiddleware = (element) => {
    if (element.root !== null || element.type === '@layer') {
        return
    }

    const wrappable = element.type === 'rule' || WRAPPABLE_AT_RULES.has(element.type)
    if (!wrappable) {
        return
    }
    if (!Array.isArray(element.children) || element.children.length === 0) {
        return
    }

    const inner: StylisElement = {
        ...element,
        parent: element,
        root: element,
        return: '',
    }

    element.type = '@layer'
    element.value = '@layer legacy'
    element.props = ['legacy']
    element.children = [inner]
    element.return = ''
}
